import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import {NavLink} from 'fluxible-router';
import { toTitleCase } from '../../lib/utils';
import styles from './index.sass';


class ProductAttributes extends React.Component {
  static propTypes = {
    attributes: React.PropTypes.array
  };

  static contextTypes = {
    buildURLForRoute: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let attrs = [];
    this.props.attributes.forEach((attr, i) => {
      let content, header;
      switch(attr.type) {
        case 'text_link':
          let { text, url } = attr.object;
          let TextElem = url ? NavLink : 'span';
          header = attr.object.header;
          content = (
            <div className={styles.textLink}>
              {header ? <label className={styles.header}>{header}</label> : null}
              {text ? <TextElem className={styles.text} href={url}>{text} {url ? <span className={styles.chevron} /> : null}</TextElem> : null}
            </div>
          );
          break;
        case 'tag_cloud':
          let { filters } = attr.object;
          header = attr.object.header;
          content = (
            <div className={styles.tagCloud}>
              {header ? <label className={styles.header}>{header}</label> : null}
              {filters.map((filter, ii) => {
                return (
                  <NavLink className={styles.tagCloudFilter} key={ii} href={this.context.buildURLForRoute('search', {filters: [filter.filter]})}>
                    {filter.filter.type === 'tag' ? toTitleCase(filter.filter.value.replace(/-/g, ' ')) : filter.filter.value}
                  </NavLink>
                );
              })}
            </div>
          );
          break;
        default:
          break;
      }
      if(content) {
        attrs.push(<div className={styles.row} key={i}>{content}</div>);
      }
    });
    if(!attrs.length) {return null;}
    return <div className={styles.attributesTable}>{attrs}</div>;
  }
}

export default ProductAttributes;



// WEBPACK FOOTER //
// banquet/components/ProductAttributes/index.js